import { Injectable } from '@angular/core';
import { IPermissionsRepo } from '../interfaces/ipermissions.repo';
import { HttpClient } from '@angular/common/http';
import { IGroupConfig, PermissionChecker } from '@socrates/common';

@Injectable()
export class PermissionsRepo extends IPermissionsRepo {
	private _deferred: Promise<PermissionChecker>;
	private _permissionChecker: PermissionChecker;

	constructor(
		private http: HttpClient,
		private groupConfig: IGroupConfig,
	) {
		super();
	}

	getPermissions(env: string): Promise<PermissionChecker> {
		if (!this._deferred) {
			if (!this._permissionChecker) {
				this._permissionChecker = new PermissionChecker(env, this.groupConfig);
			}
			this._deferred = Promise.resolve(this._permissionChecker);
		}
		return this._deferred;
	}
}
